import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="custom-fields--alert-warning"
export default class extends Controller {
  static values = {
    alertConditions: Array,
    fieldMetadata: Object,
    singleMessage: String,
    pluralMessage: String,
  };

  connect() {
    this.confirmed = false;
    this.initialFieldType = this.fieldTypeInput?.value;
  }

  confirmChange(event) {
    if (this.confirmed) return;

    const affectedCount = this.affectedAlertsCount();
    if (affectedCount === 0) return;

    if (window.confirm(this.confirmMessage(affectedCount))) {
      this.confirmed = true;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.target.value = this.initialFieldType;
  }

  confirmSubmit(event) {
    if (this.confirmed) return;

    const affectedCount = this.affectedAlertsCount();
    if (affectedCount === 0) return;

    if (window.confirm(this.confirmMessage(affectedCount))) {
      this.confirmed = true;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  affectedAlertsCount() {
    const fieldType = this.fieldTypeInput?.value;
    const metadata = this.fieldMetadataValue[fieldType];
    if (!metadata) return this.alertConditionsValue.length;

    return this.alertConditionsValue.filter((condition) => {
      return !this.alertCompatibleWithField(condition, metadata);
    }).length;
  }

  alertCompatibleWithField(condition, metadata) {
    if (!metadata.alertable) return false;

    const validMethods = metadata.valid_aggregation_methods || [];
    if (!validMethods.includes(condition.aggregation_method)) return false;

    if (
      condition.aggregation_method === "tree_presence_percentage" &&
      !this.deriveTreePresenceChecked
    ) {
      return false;
    }

    if (!metadata.multiple_choice) return true;

    const targetChoiceValue = condition.target_choice_value;
    if (!targetChoiceValue) return false;

    return this.choiceValues.includes(targetChoiceValue);
  }

  confirmMessage(count) {
    if (count === 1) return this.singleMessageValue;

    return this.pluralMessageValue.replaceAll("__COUNT__", count);
  }

  get fieldTypeInput() {
    return this.element.querySelector(
      'select[name="custom_field[field_type]"]',
    );
  }

  get choiceValues() {
    return Array.from(
      this.element.querySelectorAll(
        'input[name^="custom_field[choices_attributes]"][name$="[value]"]',
      ),
    ).map((input) => input.value);
  }

  get deriveTreePresenceChecked() {
    const input = this.element.querySelector(
      'input[name="custom_field[options][derive_tree_presence]"][type="checkbox"]',
    );
    return input?.checked === true;
  }
}
